import AppPrivate from '@/AppPrivate.vue';
import bugReportRoutes from '@/modules/bugReport/routes';
import dashboardRoutes from '@/modules/dashboard/routes';
import eventRoutes from '@/modules/events/routes';
import journeyRoutes from '@/modules/journeys/routes';
import maintenanceRoutes from '@/modules/maintenance/routes';
import { NXT_AUTH_GUARD } from '@nxtpeople/nxt-vue-keycloak';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import adminRoutes from '../modules/admin/routes';
import AUTH_GUARD from './guards/auth.guard';
import UNAVAILABLE_GUARD from './guards/unavailable.guard';
import ErrorPage from './pages/ErrorPage.vue';

export const privateRoutes: RouteRecordRaw[] = [
   {
      path: '/journey',
      name: 'journey-index',
      component: () => import('@/modules/journeys/pages/Index.vue'),
      children: journeyRoutes,
      meta: {
         permission: 'journeys',
      },
   },
   ...eventRoutes,
   ...dashboardRoutes,
   ...adminRoutes,
   ...maintenanceRoutes,
   ...bugReportRoutes,
];

export const publicRoutes: Array<RouteRecordRaw> = [
   {
      path: '/error',
      name: 'ErrorPage',
      component: ErrorPage,
      meta: { titleKey: 'errors.error' },
   },
   {
      path: '/unavailable',
      name: 'Unavailable',
      component: () => import('@/core/pages/Unavailable.vue'),
      meta: { titleKey: 'generic.unavailable.title' },
   },
];

export const routes: Array<RouteRecordRaw> = [
   {
      path: '/journey',
      name: 'AppPrivate',
      component: AppPrivate,
      children: privateRoutes,
   },
   ...publicRoutes,
   {
      path: '/:pathMatch(.*)*',
      redirect: '/journey',
   },
];

const router = createRouter({
   history: createWebHistory(),
   routes,
});

router.beforeEach(UNAVAILABLE_GUARD);

router.beforeEach((to, from, next) => NXT_AUTH_GUARD(to, from, next, { publicRoutes }));

router.beforeEach(AUTH_GUARD);

export default router;
